(() => {
  'use strict';
  if (window.TerenceV70MobileInteractions) return;
  const mobile = () => matchMedia('(max-width:749px)').matches;
  const behavior = () => matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth';
  const instances = new WeakMap();
  const youtube = frame => {try {return new URL(frame.src).origin;} catch {return 'https://www.youtube.com';}};
  function pauseMedia(scope, except) {
    scope.querySelectorAll('video').forEach(video => {if (video !== except) video.pause();});
    scope.querySelectorAll('iframe[src*="youtube.com/embed/"]').forEach(frame => {
      if (frame !== except) frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), youtube(frame));
    });
  }
  function purchaseTarget() {return document.querySelector('.product-section .product-form') || document.querySelector('[data-js-product-container]');}
  function scrollPurchase(event) {
    if (!mobile()) return;
    const target = purchaseTarget();
    if (!target) return;
    event.preventDefault();
    let headerBottom = 0;
    document.querySelectorAll('[data-header-container],.header-section,.announcement-bar').forEach(header => {
      const rect = header.getBoundingClientRect();
      if (rect.top <= 1 && rect.bottom > 0) headerBottom = Math.max(headerBottom, rect.bottom);
    });
    window.scrollTo({top:Math.max(0,scrollY + target.getBoundingClientRect().top - headerBottom - 12),behavior:behavior()});
  }
  function initGallery(section, on, cleanups) {
    const gallery = section.querySelector('.v70-theme-gallery');
    if (!gallery) return;
    const slider = gallery.querySelector('[data-js-product-media-slider]');
    const thumbs = [...gallery.querySelectorAll('[data-slide-index]')];
    const dialog = document.createElement('dialog');
    dialog.className = 'v70-image-zoom'; dialog.setAttribute('aria-label','Enlarged product image');
    const close = document.createElement('button'); close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label','Close enlarged image');
    const image = document.createElement('img');
    dialog.append(close,image); document.body.append(dialog);
    let opener = null, pointer = null, savedScroll=0, bodyStyle=null;
    on(gallery,'pointerdown',e => {pointer = {x:e.clientX,y:e.clientY};}, {passive:true});
    on(gallery,'click',e => {
      if (!mobile()) return;
      const original = e.target.closest('.terence-color-photo__open img');
      if (!original || (e.detail!==0 && pointer && (Math.abs(e.clientX-pointer.x)>8 || Math.abs(e.clientY-pointer.y)>8))) return;
      e.preventDefault(); opener = original;
      image.src = original.src; image.srcset = original.srcset; image.sizes = '100vw'; image.alt = original.alt;
      if (!dialog.open) {
        savedScroll=scrollY;bodyStyle={position:document.body.style.position,top:document.body.style.top,width:document.body.style.width};
        document.body.style.position='fixed';document.body.style.top=`${-savedScroll}px`;document.body.style.width='100%';
        dialog.showModal();
      }
    },{capture:true});
    on(close,'click',()=>dialog.close());
    on(dialog,'click',e=>{if(e.target===dialog)dialog.close();});
    const restore=()=>{if(bodyStyle){Object.assign(document.body.style,bodyStyle);bodyStyle=null;window.scrollTo({top:savedScroll,behavior:'instant'});}opener?.focus?.({preventScroll:true});};
    on(dialog,'close',restore);
    let activeVideo = null;
    const playCurrentVideo = () => {
      const video = slider?.querySelector('.swiper-slide-active video');
      if (!video || document.hidden) return;
      video.muted = true; video.defaultMuted = true; video.playsInline = true;
      const playback = video.play();
      playback?.catch(()=>{});
    };
    const sync = () => {
      const active = slider?.querySelector('.swiper-slide-active');
      const slides = [...(slider?.querySelectorAll('.v70-theme-gallery__slide') || [])];
      const index = slides.indexOf(active);
      if (index < 0) return;
      thumbs.forEach(t=>t.setAttribute('aria-current', String(Number(t.dataset.slideIndex)===index)));
      // Resume every selected video, including videos paused on an earlier visit.
      slides.forEach(slide=>{if(slide!==active)pauseMedia(slide);});
      const video = active.querySelector('video');
      if (video !== activeVideo) {activeVideo=video;playCurrentVideo();}
    };
    const observer = new MutationObserver(sync);
    slider?.querySelectorAll('.swiper-slide').forEach(slide=>observer.observe(slide,{attributes:true,attributeFilter:['class']}));
    slider?.querySelectorAll('video').forEach(video=>on(video,'loadeddata',()=>{
      if(video.closest('.swiper-slide')?.classList.contains('swiper-slide-active'))playCurrentVideo();
    }));
    let initialVariant=false,defaultTouch=null,boundSwiper=null;
    const configureSwiper = () => {
      const swiper = slider?.swiper;
      if (!swiper) return false;
      if(boundSwiper!==swiper){
        boundSwiper?.off('slideChangeTransitionEnd',playCurrentVideo);
        boundSwiper=swiper;swiper.on('slideChangeTransitionEnd',playCurrentVideo);
      }
      // Reuse the existing Swiper and thumbnail controller; do not attach another swipe handler.
      if(!defaultTouch)defaultTouch={touchAngle:swiper.params.touchAngle,threshold:swiper.params.threshold,touchStartPreventDefault:swiper.params.touchStartPreventDefault};
      if (mobile()) {swiper.allowTouchMove=true; swiper.params.touchAngle=35; swiper.params.threshold=8; swiper.params.touchStartPreventDefault=false;}
      else Object.assign(swiper.params,defaultTouch);
      if(!initialVariant){initialVariant=true;try{const json=section.querySelector('[data-selected-variant]');if(json)variantChanged({variant:JSON.parse(json.textContent)});}catch{}}
      return true;
    };
    const timer = setInterval(()=>{if(configureSwiper())clearInterval(timer);},200);
    const timeout = setTimeout(()=>clearInterval(timer),10000);
    on(window,'resize',configureSwiper,{passive:true});
    const productSection=section.matches('[data-js-product-container]')?section:section.querySelector('[data-js-product-container]');
    const variantEvent = `pdp:section-${productSection?.dataset.sectionId}:change-variant`;
    const variantChanged = ({variant}) => {
      if (!variant) return;
      const white = (variant.options || [variant.title]).some(value=>String(value).toLowerCase()==='white');
      const index = white ? 9 : 0;
      if (slider?.swiper) slider.swiper.slideTo(index,matchMedia('(prefers-reduced-motion:reduce)').matches?0:300);
    };
    let bus = null;
    const bindBus = () => {if(bus)return;bus=window.themeCore?.EventBus;if(bus)bus.listen(variantEvent,variantChanged);};
    bindBus(); on(document,'theme:all:loaded',bindBus); on(document,'product:loaded',bindBus);
    cleanups.push(()=>{boundSwiper?.off('slideChangeTransitionEnd',playCurrentVideo);observer.disconnect();clearInterval(timer);clearTimeout(timeout);dialog.close();restore();dialog.remove();bus?.remove(variantEvent,variantChanged);});
    sync();
  }
  function initSection(section) {
    if (instances.has(section)) return;
    const abort = new AbortController(), cleanups=[];
    const on=(el,type,fn,options={})=>el?.addEventListener(type,fn,{...options,signal:abort.signal});
    instances.set(section,()=>{abort.abort();cleanups.forEach(fn=>fn());});
    initGallery(section,on,cleanups);
    section.querySelectorAll('[data-v70-scroll-purchase]').forEach(link=>on(link,'click',scrollPurchase));
    section.querySelectorAll('[data-upgrades-video]').forEach(video=>{
      video.autoplay=false;video.removeAttribute('autoplay');video.controls=false;video.removeAttribute('controls');video.muted=true;video.defaultMuted=true;video.playsInline=true;
      on(video,'play',()=>{if(mobile())pauseMedia(document,video);});
    });
    // User videos play on request and pause when their card leaves the visible rail.
    section.querySelectorAll('terence-ugc-gallery').forEach(ugc=>{
      const track=ugc.querySelector('[data-ugc-track]');
      if (!track) return;
      const pauseOffscreen=()=>{
        if(!mobile())return;
        const viewport=track.getBoundingClientRect();
        track.querySelectorAll('.terence-ugc-card').forEach(card=>{
          const rect=card.getBoundingClientRect();
          if(rect.right<=viewport.left+8||rect.left>=viewport.right-8)pauseMedia(card);
        });
      };
      on(track,'scroll',pauseOffscreen,{passive:true});
      const expanded = new MutationObserver(()=>{
        const open=ugc.querySelector('.is-expanded[data-v70-youtube-player]');
        if(!open)pauseOffscreen();
      });
      expanded.observe(ugc,{subtree:true,attributes:true,attributeFilter:['class']});
      cleanups.push(()=>expanded.disconnect());
      on(ugc,'keydown',event=>{
        const open=ugc.querySelector('.is-expanded[data-v70-youtube-player]');
        if(event.key!=='Tab'||!open)return;
        const items=[...open.querySelectorAll('button:not([disabled]),a[href],iframe')].filter(el=>el.getBoundingClientRect().width>0);
        const first=items[0],last=items[items.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
      });
      const subscribe=frame=>frame.contentWindow?.postMessage(JSON.stringify({event:'listening',id:frame.id,channel:'v70'}),youtube(frame));
      ugc.querySelectorAll('iframe[src*="youtube.com/embed/"]').forEach((frame,index)=>{
        frame.id=frame.id||`v70-video-${section.id}-${index}`;
        on(frame,'load',()=>{
          subscribe(frame);
          frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'addEventListener',args:['onStateChange']}),youtube(frame));
        });
        subscribe(frame);
      });
      on(window,'message',event=>{
        if(!mobile()||!/^https:\/\/(www\.)?youtube\.com$/.test(event.origin))return;
        const frame=[...ugc.querySelectorAll('iframe')].find(item=>item.contentWindow===event.source);
        if(!frame)return;
        let data;try{data=typeof event.data==='string'?JSON.parse(event.data):event.data;}catch{return;}
        if((data?.event==='onStateChange'&&data.info===1)||(data?.event==='infoDelivery'&&data.info?.playerState===1))pauseMedia(document,frame);
      });
    });
    const videoObserver = new IntersectionObserver(entries=>entries.forEach(entry=>{
      // Gallery autoplay is controlled by its existing module.
      if(mobile()&&!entry.isIntersecting&&!entry.target.closest('.v70-theme-gallery'))entry.target.pause();
    }),{threshold:0});
    section.querySelectorAll('video').forEach(video=>videoObserver.observe(video));
    section.querySelectorAll('video').forEach(video=>on(video,'play',()=>{
      const gallery=video.closest('.v70-theme-gallery');
      // A queued play event from the outgoing slide must never pause the new one.
      if(gallery&&!video.closest('.swiper-slide')?.classList.contains('swiper-slide-active')){video.pause();return;}
      if(mobile())pauseMedia(document,video);
    }));
    cleanups.push(()=>videoObserver.disconnect());
  }
  function init(scope=document) {
    const sections=[...scope.querySelectorAll('.shopify-section')];
    if(scope.matches?.('.shopify-section'))sections.push(scope);
    sections.forEach(initSection);
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest('.v70-apple-hero a');
    if(link && /#[^#]*product-template$/.test(link.getAttribute('href')||''))scrollPurchase(event);
  });
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{
    [e.target,...e.target.querySelectorAll('.shopify-section')].forEach(section=>{instances.get(section)?.();instances.delete(section);});
  });
  document.addEventListener('visibilitychange',()=>{if(document.hidden)pauseMedia(document);});
  // Raise the support launcher only while the existing floating purchase bar is visible.
  let scheduled=false;
  const clearance=()=>{
    scheduled=false;
    const bar=document.querySelector('.v70-floating-cart'),rect=bar?.getBoundingClientRect();
    const visible=mobile()&&rect&&getComputedStyle(bar).visibility!=='hidden'&&getComputedStyle(bar).display!=='none'&&rect.top<innerHeight&&rect.bottom>0;
    document.documentElement.style.setProperty('--v70-buybar-clearance',visible?`${Math.max(0,innerHeight-rect.top)}px`:'0px');
  };
  const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(clearance);}};
  window.addEventListener('scroll',schedule,{passive:true}); window.addEventListener('resize',schedule,{passive:true});
  window.TerenceV70MobileInteractions={init,pauseMedia};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{init();clearance();},{once:true});else{init();clearance();}
})();

